import { Page, writeAnim } from "./Item";
import "../styles/chat.css";
import { useEffect } from "react";
import { PreviewCard } from "./Projects/Projects";

function Content({ itemInfo }) {
  let iconLink = "https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/";
  const aboutMe = {
    text: "> Software Engineering graduate with hands-on experience in full-stack web development, API development using Node.js, and game development through internships and self-driven projects. Passionate about learning new technologies and building innovative, scalable applications.",
    socialLinks: [
      {
        name: "linkedin",
        link: "https://www.linkedin.com/in/amantes30",
        icon: "/linkedin.svg",
      },
      {
        name: "github",
        link: "https://github.com/amantes30",
        icon: `${iconLink}github.svg`,
      },
      {
        name: "unity",
        link: "https://learn.unity.com/u/6041e681edbc2a001f6e3530?tab=profile",
        icon: `${iconLink}unity.svg`,
      },
      {
        name: "microsoftlearn",
        link: "https://learn.microsoft.com/en-us/users/amanuel-0733/transcript/v0g8wa135rrkg6j",
        icon: "https://learn.microsoft.com/favicon.ico",
      },
    ],
    projects: [
      {
        title: "Photos",
        description:
          "This website integrates Unsplash's API to retrieve client's pictures and showcase in the portfolio",
        imagelink: "/image/yosias G.png",
        link: "https://yozz1.pages.dev",
      },
      {
        title: "Text-to-Image",
        description:
          "This website uses SD-XL 1.0-base Model Card to convert text to image",
        imagelink: "/image/text-to-img(thumb).jpg",
        link: "https://amantes30.github.io/text-to-image/",
      },
      {
        title: "Translator",
        description: "Translator website that uses Gemini to translate text",
        imagelink: "/image/translator.png",
        link: "https://translator-cj1.pages.dev",
      },

      {
        title: "Weather Site",
        description:
          "This website uses 7Timer API to retrieve 7 day weather forecast for different cities",
        imagelink: "/image/weathersite.png",
        link: "https://weather-112.pages.dev",
      },
      {
        title: "Terminal I/O",
        description: "Plain HTML, CSS & JS Terminal I/O",
        imagelink: "https://amantes30.github.io/Custom-Input/screenshot.png",
        link: "https://amantes30.github.io/Custom-Input/",
      },
    ],
  };
  useEffect(() => {
    writeAnim(aboutMe.text, document.getElementById("intro"), 10);
  }, []);
  return (
    <>
      <main>
        <div
          className="page df w100"
          style={{ animationTimeline: "view(99% 1%)" }}
        >
          <div
            className="pfp w100"
            style={{ animationTimeline: "view(10% 90%)" }}
          >
            <img alt="pfp" src="/image/pfp.webp" />
          </div>

          <h1 className="g-c-text" id="name">
            {itemInfo.user.idinfo[0].firstname}
          </h1>
          <h3
            className="g-c-text"
            id="degree"
            onMouseEnter={() => {
              document.getElementById("degree-img").style.scale = "1";
            }}
            onMouseLeave={() => {
              document.getElementById("degree-img").style.scale = "0";
            }}
          >
            {itemInfo.user.idinfo[0].profession}
            <div id="degree-img">
              <img className="w100" src="/image/degree.webp" alt={"degree"} />
            </div>
          </h3>
          <ul className="social-links df">
            {aboutMe.socialLinks.map((link, idx) => {
              return (
                <>
                  <li key={idx}>
                    <a href={link.link}>
                      <img alt={link.name} src={link.icon} />
                    </a>
                  </li>
                  |
                </>
              );
            })}

            <li>
              <a
                className="p-btn resumeBtn"
                href="/SEResume.pdf"
                download={"SEResume.pdf"}
              >
                <img
                  style={{ width: "20px", height: "16px" }}
                  src="/image/download-icon.svg"
                  alt="download"
                />
                <span>CV</span>
              </a>
            </li>
          </ul>

          <section className="console">
            <span>{">_ "}</span>
            <p id="intro"></p>
          </section>
        </div>

        <div className="page experience-item df">
          {itemInfo.site === "en" ? (
            <h2 className="title g-c-text" style={{ textAlign: "center" }}>
              Education
            </h2>
          ) : (
            <h2 className="title g-c-text" style={{ textAlign: "center" }}>
              学习
            </h2>
          )}

          <ul className="df list-education">
            <li className=" experience-card">
              <img
                src={
                  "https://www.nuaa.edu.cn/_upload/tpl/05/f7/1527/template1527/images/logo_b.png"
                }
              />
              <div>
                <a
                  style={{ color: "white", textDecoration: "none" }}
                  href={"https://www.nuaa.edu.cn/"}
                >
                  <p className="company-name">
                    {itemInfo.site === "en"
                      ? "Nanjing University of Aeronautics and Astronautics"
                      : "南京航空航天大学"}
                  </p>
                </a>
                <hr />
                {/* <p>{experience["job"]} <span style={{ display: "block" }}>{experience.description}</span></p> */}
                <p className="experience-title">
                  Bachelor in Computer Science and Technology{" "}
                </p>
                <ul className="experience-desc">
                  <li>Date: Sep 2017 - July 2021</li>
                  <li>GPA: 2.9</li>
                </ul>
              </div>
            </li>
            <li className=" experience-card">
              <img
                src={
                  "https://www.nuaa.edu.cn/_upload/tpl/05/f7/1527/template1527/images/logo_b.png"
                }
              />
              <div>
                <a
                  style={{ color: "white", textDecoration: "none" }}
                  href={"https://www.nuaa.edu.cn/"}
                >
                  <p className="company-name">
                    {itemInfo.site === "en"
                      ? "Nanjing University of Aeronautics and Astronautics"
                      : "南京航空航天大学"}
                  </p>
                </a>
                <hr />
                {/* <p>{experience["job"]} <span style={{ display: "block" }}>{experience.description}</span></p> */}
                <p className="experience-title">
                  {" "}
                  Masters in Computer Science and Technology{" "}
                </p>
                <ul className="experience-desc">
                  <li>Date: Sep 2021 - Present</li>
                </ul>
              </div>
            </li>
            <li className=" experience-card">
              <img
                src={
                  "https://frontends.udemycdn.com/frontends-homepage/staticx/udemy/images/v7/logo-udemy.svg"
                }
              />
              <div>
                <a
                  style={{ color: "white", textDecoration: "none" }}
                  href={"https://www.nuaa.edu.cn/"}
                >
                  <p className="company-name"> Udemy</p>
                </a>
                <hr />
                {/* <p>{experience["job"]} <span style={{ display: "block" }}>{experience.description}</span></p> */}
                <p className="experience-title"> Ethical hacking </p>
                <ul className="experience-desc">
                  <li>Date: Sep 01 2021 - Jan 25 2021</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div
          className="page projects w100 "
          style={{ animationTimeline: "view(99% 1%)" }}
        >
          {itemInfo.site === "en" ? (
            <h2 className="title g-c-text">Projects</h2>
          ) : (
            <h2 className="title g-c-text">项目</h2>
          )}

          <div className="project-view df">
            <div className="active-item df">
              <h1 className="project-title">
                Projects Preview <span>Done</span>
              </h1>
              <p>Hover Over Projects to see more details</p>

              <a id="learn-more-btn" className="p-btn">
                <span>Visit Site</span>
              </a>
            </div>
            <img
              id="active-img"
              className="w100"
              src=""
              alt="project-preview-image"
            />
            <section className={"project-list df"}>
              {aboutMe.projects.map((project, index) => {
                return (
                  <PreviewCard
                    title={project.title}
                    description={project.description}
                    link={project.link}
                    imageLink={project.imagelink}
                    key={index}
                  />
                );
              })}
            </section>
          </div>
        </div>

        <Page itemInfo={itemInfo} type={"skills"} />
        <div className="page  df experience-item ">
          {itemInfo.site === "en" ? (
            <h2 className="title g-c-text">Experience</h2>
          ) : (
            <h2 className="title g-c-text">实习</h2>
          )}

          <ul className="df p0" style={{ justifyContent: "center" }}>
            {itemInfo.user.experiences.map((experience, idx) => {
              return (
                <li className=" experience-card" key={idx}>
                  <img src={experience.logoUrl} />
                  <div>
                    <a
                      style={{ color: "white", textDecoration: "none" }}
                      href={"https://" + experience.link}
                    >
                      <p className="company-name">{experience.organization}</p>
                    </a>
                    <hr />
                    {/* <p>{experience["job"]} <span style={{ display: "block" }}>{experience.description}</span></p> */}
                    <p className="experience-title">Game Developer Intern </p>
                    <ul className="experience-desc">
                      <li>
                        Contributed to the development of game mechanics and
                        logic using Unity Game Engine.
                      </li>
                      <li>
                        {" "}
                        Assisted in debugging and refining gameplay features to
                        enhance user experience.
                      </li>
                      <li> Autodesk 3dsMax training.</li>
                      <li>
                        {" "}
                        Worked in an Agile team environment to project
                        deadlines.
                      </li>
                    </ul>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        <Page itemInfo={itemInfo} type={"chatbox"} />
      </main>
    </>
  );
}
export default Content;
